import * as css from "./NavbarHome.module.scss";
import { useState } from 'react';

function NavLogoHome() {
    const logoUrl = new URL('../../images/enkindle-logo.png', import.meta.url);
    
    return (
        <div className={css.logoBox}>
            <a className={css.logoHomeLink} href="/">
                <img src={logoUrl} alt="Enkindle Logo" className={css.logo} />
            </a>
        </div>
    )
}

export function NavbarHome({scrollHandlers}) {
    const mmUrl = new URL('../../images/mm.svg', import.meta.url);
    const [cssMmClass, setcssMmClass] = useState(css.navMobileClosed);

    const handleMobileMenuVisibility = () => {
        if (cssMmClass == css.navMobileClosed) {
            setcssMmClass(css.navMobile);
            document.querySelector('body').style.overflowY = 'hidden';
        } else {
            setcssMmClass(css.navMobileClosed);
            document.querySelector('body').style.overflowY = 'auto';
        }
    }

    const handleMissionGoto = () => {
        handleMobileMenuVisibility();
        scrollHandlers.mission();
    }

    const handleEventsGoto = () => {
        handleMobileMenuVisibility();
        scrollHandlers.events();
    }

    const handleContactimoniesGoto = () => {
        handleMobileMenuVisibility();
        scrollHandlers.contact();
    }
    
    return (
        <>
            <nav className={css.navFlexWrapper}>
                <NavLogoHome/>
                
                <button onClick={handleMobileMenuVisibility} className={css.mobileMenuTrigger} >
                    <img src={mmUrl} alt="mobile menu" className={css.mmImage} />
                </button>

                <ul className={cssMmClass}>
                    <li className={css.closeMMBox}><a onClick={handleMobileMenuVisibility} className={css.closeMM}><span>X</span></a></li>
                    <li><button className={css.LinkMobile} onClick={handleMissionGoto}>Mission</button></li>
                    <li><button className={css.LinkMobile} onClick={handleEventsGoto}>Events</button></li>
                    <li><button className={css.LinkMobile} onClick={handleContactimoniesGoto}>Contact</button></li>
                    <li><a className={css.LinkMobile} target="_blank" href="https://www.paypal.com/donate/?hosted_button_id=D58VKGKRB74BC">Donate</a></li>
                </ul>
                <ul className={css.navDesktop}>
                    <li><button className={css.navDesktopLink} onClick={scrollHandlers.mission}>Mission</button></li>
                    <li><button className={css.navDesktopLink} onClick={scrollHandlers.events}>Events</button></li>
                    <li><button className={css.navDesktopLink} onClick={scrollHandlers.contact}>Contact</button></li>
                    <li><a className={`${css.navDesktopLink} ${css.navDesktopLinkHighlight}`} target="_blank" href="https://www.paypal.com/donate/?hosted_button_id=D58VKGKRB74BC">Donate</a></li>
                </ul>
            </nav>
        </>
    );
  }